// Maps the app's UI language code to a BCP-47 locale for date/time formatting.
const LOCALES = Object.freeze({
  en: "en-US",
  es: "es-ES",
  hi: "hi-IN",
  fr: "fr-FR",
  zh: "zh-CN",
  ja: "ja-JP",
  ko: "ko-KR",
  de: "de-DE",
  it: "it-IT",
  ru: "ru-RU",
  ar: "ar",
  gu: "gu-IN",
  te: "te-IN",
  mr: "mr-IN",
  pt: "pt-BR",
})

const DEFAULT_LOCALE = "en-US"

export function toBcp47Locale(lang) {
  return LOCALES[lang] || DEFAULT_LOCALE
}
